import {
  FC,
  JSX,
  ReactNode
} from "react";
import { View, Text } from "react-native";
import { formatDays } from "@/_utils/formatDate";
import css from "./InfoCard.module.css";

interface ICardProps {
  title: string;
  subscribeDaysLeft?: number;
  isSubscriptionAlmostOver?: boolean;
  children: ReactNode;
  onDetailsPress?: () => void;
}

const InfoCard: FC<ICardProps> = ({
  title,
  subscribeDaysLeft,
  isSubscriptionAlmostOver,
  children,
  onDetailsPress,
}): JSX.Element => {
  return (
    <View className={css.container}>
      <View className="flex-row justify-between px-5 pt-5">
        <Text className="text-black text-md">
          {title}
          {isSubscriptionAlmostOver && (
            <Text className="ml-3 text-red-500 bg-red rounded-3xl px-2 py-1 text-sm">
              {formatDays(subscribeDaysLeft ?? 0)}
            </Text>
          )}
        </Text>
        <Text
          className="text-gray text-sm"
          onPress={onDetailsPress}
        >
          Подробнее
        </Text>
      </View>
      <View>{children}</View>
    </View>
  );
};

export default InfoCard;
